export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Pants_BaseColor.50ab836f.tga";